export default "__VITE_ASSET__BzssK2ym__"